export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7811.a778168a.jpg";